module.exports = __webpack_public_path__ + "static/media/empty-state-maintenance.8de3bfd6.svg";